<template>
  <div class="detail-container">
    <el-row class="tcf-row">
      <div class="card">
        <div class="card-body">
          <div class="card-content" v-loading="loading">
            <div class="detail-title">{{ noticeTitle }}</div>

            <div class="detail-info">
              <span><svg-icon icon-class="group" />{{noticeData.deptName}}-{{noticeData.username}}</span>
              <span style="margin: 0 20px;"><i class="el-icon-time" style="margin-right: 4px" />
                {{ noticeData.createTime?noticeData.createTime.split('.')[0]:'' }}
              </span>
              <el-popover placement="bottom-start" trigger="hover">
                <div class="user-list">
                  <div v-if="noticeUser.length > 0" style="padding-bottom: 8px; font-size: 14px;">员工</div>
                  <div class="user-item" v-for="(u, i) in noticeUser" :key="'u'+i">
                    <el-avatar :size="50" fit="cover" :src="!!u.photo?u.photo:u.sex==='男'?men:women"></el-avatar>
                    <div class="name">{{ u.username }}</div>
                  </div>
                  <div v-if="noticeDealer.length > 0" style="padding-bottom: 8px; font-size: 14px;">经销商</div>
                  <div class="user-item" v-for="(u, i) in noticeDealer" :key="'d'+i">
                    <el-avatar :size="50" fit="cover" :src="!!u.photo?u.photo:u.sex==='男'?men:women"></el-avatar>
                    <div class="name">{{ u.username }}</div>
                  </div>
                </div>
                <span slot="reference" style="color:#409EFF;cursor: pointer;">
                  <i class="el-icon-view" style="margin-right: 4px" />
                  {{ noticeData.readNum || 0 }}人已读
                </span>
              </el-popover>
            </div>

            <div style="background: #f6f8fa;margin-top: 20px;padding: 20px; position: relative;">
              {{ noticeData.content }}
              <div style="width: 100%; text-align: center; margin-top: 24px;">
                <el-link :underline="false" style="font-size: 13px;" @click="toArchive">
                  点此前往档案库查看
                </el-link>
              </div>
            </div>

            <!-- <div style="padding:20px">
              <div class="detail-file-title" v-if="noticeData.fileId">
                关联文件:
              </div>
              <div class="detail-file" v-if="noticeData.fileId">
                <div class="file-box" @click="downLoad" :title="`${noticeData.fileName}`">
                  <div class="file-icon">
                    <i class="el-icon-document" />
                  </div>
                  <div class="file-name">
                    <span>{{noticeData.fileName}}</span>
                  </div>
                </div>
              </div>
            </div> -->

          </div>
        </div>
      </div>
    </el-row>
  </div>
</template>

<script>
  import {
    getUser
  } from '@/utils/auth'
  import {
    getFileNoticeDetail
  } from '@/api/archive'
  import {
    getFileInfo
  } from '@/api/pub'
  import men from '@/assets/photo_men.jpg'
  import women from '@/assets/photo_women.jpg'

  export default {
    name: 'file_notice_detail',
    data() {
      return {
        men: men,
        women: women,
        nid: '',
        loading: false,
        noticeData: [],
        noticeTitle: '',
        noticeUser: [],
        noticeDealer: [],
      }
    },
    computed: {
      user: getUser
    },
    created() {
      this.tempRoute = Object.assign({}, this.$route)
      this.nid = this.$route.params && this.$route.params.nid
      this.getNoticeDetail()
    },
    methods: {
      toArchive() {
        if (this.noticeData.id) {
          this.$router.push({
            path: '/work/archive/' + this.noticeData.kindId,
            query: {
              kind: this.noticeData.kindId,
              directory: this.noticeData.folderId
            }
          });
        }
      },

      getNoticeDetail() {
        this.loading = true
        const data = {
          id: this.nid,
          userId: this.user.dUserid || this.user.userid || '',
          dealerId: this.user.delid || ''
        }
        getFileNoticeDetail(data).then(response => {
          this.noticeData = response.data || {}
          this.noticeTitle = this.noticeData.title || ''
          this.noticeUser = this.noticeData.userReadList || []
          this.noticeDealer = this.noticeData.dealerReadList || []
          this.setTagsViewTitle()
          this.loading = false
        })
      },

      setTagsViewTitle() {
        const route = Object.assign({}, this.tempRoute, {
          title: `${this.noticeTitle}`
        })
        this.$store.dispatch('tagsView/updateVisitedView', route)
      },

    }
  }
</script>

<style lang="scss" scoped>
  .detail-container {
    .tcf-row {
      .card {
        .card-body {
          .card-content {
            .detail-title {
              font-size: 25px;
            }

            .detail-info {
              margin-top: 20px;
              padding-left: 10px;
            }

            .detail-file {
              width: 100%;
              margin-bottom: .6rem;
              position: relative;
              box-sizing: border-box;

              .file-box {
                width: 120px;
                height: 127px;
                float: left;
                margin: 4px 0 0 6px;
                text-align: center;
                position: relative;
                border-radius: 5px;
                font-size: 12px;

                .file-icon {
                  font-size: 55px;
                  position: relative;
                  margin: 9px auto 0;
                  width: 74px;
                  height: 74px;
                  overflow: hidden;
                  cursor: pointer;
                }

                .file-name {
                  display: block;
                  margin: 6px 5px 5px;

                  span {
                    cursor: pointer;
                    color: #424e67;
                    text-decoration: none;
                  }
                }
              }
            }

            .detail-file-title {
              font-size: 13px;
            }
          }
        }
      }
    }
  }

  .user-list {
    max-width: 440px;
    position: relative;
    max-height: 400px;
    overflow-y: auto;
    padding: 10px;

    .user-item {
      width: 50px;
      height: 80px;
      float: left;
      margin-right: 20px;
      margin-bottom: 20px;

      .name {
        width: 100%;
        position: relative;
        text-align: center;
        font-size: 12px;
        font-weight: 500;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
</style>
